import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
    root: {
        width: '100vw',
        margin: '0 auto',
        paddingTop: '100px',
    },
    iconWarning: {
        height: '5em',
        width: '5em',
        color: 'orange',
    },
    txtMessage: {
        fontWeight: 'bold',
        fontSize: '1.1rem',
    },
}));